import React, { useRef, useState, useEffect } from "react";
import {
  Form,
  DatePicker,
  Radio,
  Row,
  Col,
  Select,
  Input,
  Button,
  Table,
  message,
  Popconfirm,
} from "antd";
import moment from "moment";
import { request } from "../../../utils/fetch";
import { getRelevanceCompany } from "../../../api/api";
import store from "../../../store/index";
// 导入模态框
import ImportModal from "./ImportModal";

const { RangePicker } = DatePicker;
const { Option } = Select;

const itemStyle = { width: "300px", marginRight: "15px" };
const labelStyleObj = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
};

const Orders = (props) => {
  let path = "platform:staffOrder:insert";

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const modalRef = useRef(null); // 模态框ref
  const [companyCodeList, setcompanyCodeList] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `共 ${total} 条`,
  });
  useEffect(() => {
    getRelevanceCompanyall();
    getTableData();
  }, []);
  const handlerChange = (dates, dateStrings) => {
    if (dates === null) {
      form.setFieldsValue({
        rangeDate: null,
      });
    }
  };
  // 获取所有企业
  const getRelevanceCompanyall = async () => {
    const res = await getRelevanceCompany();
    if (res) {
      setcompanyCodeList(res);
    }
  };
  const radioChange = (e) => {
    const startDate = moment()
      .subtract(e.target.value - 1, "days")
      .format("YYYY-MM-DD");
    const endDate = moment().format("YYYY-MM-DD");
    form.setFieldsValue({
      rangeDate: [moment(startDate), moment(endDate)],
    });
  };
  // 重置
  const resetForm = () => {
    form.resetFields();
  };
  // 查询
  const submit = () => {
    // 查询时重置到第一页
    setPagination({
      ...pagination,
      current: 1,
    });
    getTableData({ pageNum: 1 });
  };
  const handleTableChange = (pagination) => {
    setPagination({
      ...pagination,
    });
    getTableData({
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    });
  };
  // 获取数据列表
  const getTableData = async (pageParams = {}) => {
    const { keyword, rangeDate, companyCodeList } = form.getFieldsValue();
    setLoading(true);
    const params = {
      keyword,
      beginTime: rangeDate ? moment(rangeDate[0]).format("YYYY-MM-DD") : "",
      endTime: rangeDate ? moment(rangeDate[1]).format("YYYY-MM-DD") : "",
      companyCode: companyCodeList,
      pageNum: pageParams.pageNum || pagination.current,
      pageSize: pageParams.pageSize || pagination.pageSize,
    };
    try {
      const res = await request.get("/platform/staffOrder/list", params);
      setTableData(res.list);
      setPagination({
        ...pagination,
        total: res.totalCount,
        current: pageParams.pageNum || pagination.current,
        pageSize: pageParams.pageSize || pagination.pageSize,
      });
    } catch (error) {
      message.error(error);
    } finally {
      setLoading(false);
    }
  };
  // 导出
  const exportExcel = async () => {
    try {
      const { keyword, rangeDate, companyCodeList } = form.getFieldsValue();
      const params = {
        keyword,
        beginTime: rangeDate ? moment(rangeDate[0]).format("YYYY-MM-DD") : "",
        endTime: rangeDate ? moment(rangeDate[1]).format("YYYY-MM-DD") : "",
        companyCodde: companyCodeList,
      };
      request.downloadTemplate("/platform/staffOrder/export", params);
    } catch (error) {
      message.error(error);
    }
  };
  // 导入
  const importExcel = () => {
    modalRef.current.showModal();
  };
  // 导入成功回调
  const handleSuccess = () => {
    getTableData();
  };
  // 删除
  const deleteOrder = async (record) => {
    try {
      const res = await request.post("/platform/staffOrder/delete", {
        id: record.id,
      });
    } catch (error) {
      message.error(error);
    } finally {
      getTableData();
    }
  };
  // 列表字段
  const tableColumns = [
    {
      title: "企业",
      dataIndex: "companyName",
      key: "companyName",
      width: 180,
      align: "center",
    },
    {
      title: "项目",
      dataIndex: "projectName",
      key: "projectName",
      align: "center",
    },
    {
      title: "姓名",
      dataIndex: "name",
      key: "name",
      align: "center",
    },
    {
      title: "身份证号",
      dataIndex: "idNumber",
      key: "idNumber",
      align: "center",
    },
    {
      title: "实发金额",
      dataIndex: "realAmount",
      key: "realAmount",
      align: "center",
    },
    {
      title: "个税",
      dataIndex: "tax",
      key: "tax",
      align: "center",
    },
    {
      title: "应发金额",
      dataIndex: "shouldAmount",
      key: "shouldAmount",
      align: "center",
    },
    {
      title: "收款账号",
      dataIndex: "bankNumber",
      key: "bankNumber",
      align: "center",
    },
    {
      title: "开户行",
      dataIndex: "bankName",
      key: "bankName",
      align: "center",
    },
    {
      title: "城市",
      dataIndex: "cityName",
      key: "cityName",
      align: "center",
    },
    {
      title: "月份",
      dataIndex: "month",
      key: "month",
      align: "center",
    },
    {
      title: "签署情况",
      dataIndex: "signRemark",
      key: "signRemark",
      align: "center",
    },
    {
      title: "主体",
      dataIndex: "mainRemark",
      key: "mainRemark",
      align: "center",
    },
    {
      title: "操作",
      dataIndex: "operation",
      key: "operation",
      align: "center",
      render: (_, record) =>
        store.getState().userReducer.permissions.includes(path) && (
          <Popconfirm
            title="确认删除吗？"
            onConfirm={() => deleteOrder(record)}
            okText="确认"
            cancelText="取消"
          >
            <Button type="link" danger>
              删除
            </Button>
          </Popconfirm>
        ),
    },
  ];

  return (
    <div>
      <Form form={form} {...labelStyleObj} labelAlign="left">
        <Row>
          <Form.Item label="时间" name="rangeDate">
            <RangePicker
              allowClear
              format={"YYYY-MM-DD"}
              onChange={handlerChange}
            />
          </Form.Item>
          <Form.Item style={{ width: "600px", marginLeft: "15px" }}>
            <Radio.Group onChange={radioChange}>
              <Radio value={1}>今天</Radio>
              <Radio value={7}>近7天</Radio>
              <Radio value={30}>近30天</Radio>
            </Radio.Group>
          </Form.Item>
        </Row>
        <Row>
          <Form.Item label="企业名称" name="companyCodeList" style={itemStyle}>
            <Select
              allowClear
              placeholder="全部"
              showSearch
              optionFilterProp="children"
            >
              {companyCodeList.map((e) => (
                <Option key={e.companyCode} value={e.companyCode}>
                  {e.companyName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item style={itemStyle} name="keyword" label="关键字">
            <Input placeholder="姓名丨身份证号丨手机号 | 所在城市" />
          </Form.Item>
        </Row>
        <Row>
          <Col span={24} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={submit}
              style={{ marginRight: "15px" }}
            >
              查询
            </Button>
            <Button onClick={resetForm}>重置</Button>
            <Button
              type="primary"
              style={{ marginLeft: "15px" }}
              onClick={exportExcel}
            >
              导出
            </Button>
            {store.getState().userReducer.permissions.includes(path) && (
              <Button
                type="primary"
                style={{ marginLeft: "15px" }}
                onClick={importExcel}
              >
                导入
              </Button>
            )}
          </Col>
        </Row>
      </Form>
      <Table
        columns={tableColumns}
        dataSource={tableData}
        pagination={pagination}
        onChange={handleTableChange}
        bordered
        size="middle"
        loading={loading}
        rowKey={(record) => record.id}
      />
      <ImportModal ref={modalRef} onSuccess={handleSuccess} />
    </div>
  );
};

export default Orders;
